import React, { useState, useEffect, useRef } from "react";
import "../styles/SupportCenter.css";
import { useNavigate } from "react-router-dom";

const TREES = {
    admin: {
        root: {
            prompt: "What do you need help with?",
            options: [
                { label: "Product Licenses", next: "licenses_root" },
                { label: "Product Details", next: "products_root" },
                { label: "Production Units & Users", next: "units_root" },
                { label: "Qrmor Codes", next: "qrmor_root" },
                { label: "Reports & Analytics", next: "reports_root" },
                { label: "Something else", next: "other_escalate" },
            ],
        },

        // ---------------- Licenses ----------------
        licenses_root: {
            prompt: "Product Licenses — what do you need?",
            options: [
                { label: "Activate a new license", next: "license_activate" },
                { label: "Check a license's status", next: "license_status" },
                { label: "Renew an expired license", next: "license_renew" },
                { label: "License is stuck or rejected", next: "license_escalate" },
                { label: "Details on the license are wrong", next: "license_details_escalate" },
                { label: "Something else", next: "license_other_escalate" },
            ],
        },
        license_activate: {
            answer:
                "Check your email for a License Key → Login to QRmor portal → Select Add Product Details → Enter the License Key you copied from your email and Validate.<br /><br /><b>Note: The License Key gets activated only when you add product details after validating the key</b>",
        },
        license_status: {
            answer:
                "Login to QRmor portal → Select QRmor Licenses → Search for a product by product name to get the License Status.",
        },
        license_renew: {
            answer:
                "Check your email for a renewed License Key → Login to QRmor portal → Under Actions Column you will be asked for Licence Renewal → Click on it → Enter the License Key you copied from your email and Validate.<br /><br /><b>Note: No Further actions required. Once the License is validated and approved, you can continue using the platform as before</b>",
        },
        license_escalate: {
            escalate: true,
            escalateNote: "License activation issues need a manual check — share the Product Name and what happened.",
        },
        license_details_escalate: {
            escalate: true,
            escalateNote: "Corrections to an active license need verification — tell us what's incorrect and the Product Name.",
        },
        license_other_escalate: {
            escalate: true,
            escalateNote: "Tell us what's going on and we'll follow up by email.",
        },

        // ---------------- Products ----------------
        products_root: {
            prompt: "Products — what do you need?",
            options: [
                { label: "Add a new product", next: "add_product" },
                { label: "Edit an existing product", next: "edit_product" },
                { label: "Something else", next: "product_other_escalate" },
            ],
        },
        add_product: {
            answer:
                "Activate the license first → It will prompt for the Product Details → Add Details, upload the product image, and enter Unique Product Identification code, Generic name, manufacturing Lic. No. List of Excipients, Visit Use URl for giving further information and select the Production Unit where the product is manufactured and  Add Product. <br/><br/><b>Note: The Product Details editing window is open only for 24 hours from the time the product was added to the platform. After 24 hours, you cannot edit the product details.</b>",
        },
        edit_product: {
            answer:
                "Login to QRmor portal → Select the View & Edit option for a product (if within edit window) → Click on Edit → Make the changes and Save.<br/><br/><b>Note: The Product Details editing window is open only for 24 hours from the time the product was added to the platform. After 24 hours, you cannot edit the product details.</b>",
        },
        product_other_escalate: {
            escalate: true,
            escalateNote: "Tell us what's going on and we'll follow up by email.",
        },

        // ---------------- Production units ----------------
        units_root: {
            prompt: "Production Units & Users — what do you need?",
            options: [
                { label: "Add a Production Unit", next: "add_unit" },
                { label: "Add users to a Production Unit", next: "add_unit_user" },
                { label: "Production Unit isn't showing up", next: "unit_missing_escalate" },
                { label: "Something else", next: "unit_other_escalate" },
            ],
        },
        add_unit: {
            answer:
                "Login to QRmor portal → Select Production Unit Management → Click on Add Production Unit → Enter the Production Unit Name & Address and click Add Production Unit.<br /><br /><b>Note: The Production Unit Name cannot be updated or edited. Only the Production Unit Address can be edited.</b>",
        },
        add_unit_user: {
            answer:
                "Login to QRmor portal → Select Production Unit Management → Click on Add Users → Select the Production Unit the User belongs to and Enter their Employee ID, Name and Email.",
        },
        unit_missing_escalate: {
            answer:
                "If a Production Unit isn't showing up, it may not be registered in the system. If already registered then use the pagination button to move to next or previous to view if other Units are present.",
        },
        unit_other_escalate: {
            escalate: true,
            escalateNote: "Tell us what's going on and we'll follow up by email.",
        },

        // ---------------- QRmor Codes ----------------
        qrmor_root: {
            prompt: "QRmor Codes — what do you need?",
            options: [
                { label: "Generate a QRmor Code", next: "qrmor_generate" },
                { label: "QRmor Document", next: "qrmor_doc" },
                { label: "Something else", next: "other_escalate" }
            ],
        },
        qrmor_generate: {
            prompt: "QRmor Codes Generation - what do you need?",
            options: [
                { label: "How to Generate?", next: "qrmor_generate_generation" },
                { label: "Generation Issue", next: "qrmor_generate_escalate" },
            ],
        },
        qrmor_generate_generation: {
            answer:
                "Login to QRmor portal → Click on 'Generate QR and View Details' for the product you want to generate QR→ Click on Generate QR → Select the QRmor code type that you want to generate ad click 'Generate'.",
        },
        qrmor_generate_escalate: {
            escalate: true,
            escalateNote: "Share what issue you faced during the QRmor code generation and our team will check it.",
        },
        qrmor_doc: {
            prompt: "QRmor Codes Document - what do you need?",
            options: [
                { label: "How to Download?", next: "qrmor_doc_down" },
                { label: "Document Issue", next: "qrmor_doc_escalate" },
            ],
        },
        qrmor_doc_down: {
            answer:
                "Login to QRmor portal → Click on 'Generate QR and View Details' for the product you want to Download Document→ Click on 'CDR' option for the QR ID you want to generate the QRmor Document' → The Document downloads.",
        },
        qrmor_doc_escalate: {
            escalate: true,
            escalateNote: "Share what issue you faced with the QRmor code Document and our team will check it.",
        },

        // ---------------- Reports ----------------
        reports_root: {
            prompt: "Reports & Analytics — what do you need?",
            options: [
                { label: "Reports Available", next: "reports_avail" },
                { label: "How do generate?", next: "reports_howto" },
                { label: "I'm facing an issue", next: "reports_custom_escalate" },
            ],
        },
        reports_avail: {
            answer: "There are 4 reports available in the system:<br/><br/>1. Analytics Report<br/>&nbsp;&nbsp;&nbsp;1.1. Verification Count Analytics Report<br/>&nbsp;&nbsp;&nbsp;1.2. QRs per Product Report<br/>&nbsp;&nbsp;&nbsp;1.3. QR Generation Timeline Report<br/>2. Product Report<br/>3. QR Report<br/>4. Batch Report",
        },
        reports_howto: {
            prompt: "Which report are you looking for?",
            options: [
                { label: "Verification Count Analytics Report", next: "report_ver_count" },
                { label: "QRs per Product Report", next: "report_qr_prod" },
                { label: "QR Generation Timeline Report", next: "report_qr_gen" },
                { label: "Product Report", next: "report_prod" },
                { label: "QR Report", next: "report_qr" },
                { label: "Batch Report", next: "report_batch" },
            ],
        },
        report_ver_count: {
            answer: "Login to QRmor portal → Click on QRmor Analytics → Select Verification Count (if not already selected) → Click on View Report → Select the Product Name & date range and click on Generate Report.",
        },
        report_qr_prod: {
            answer: "Login to QRmor portal → Click on QRmor Analytics → Select QRs per Product (if not already selected) → Click on View Statistics.",
        },
        report_qr_gen: {
            answer: "Login to QRmor portal → Click on QRmor Analytics → Select QR Generation Timeline (if not already selected) → Click on View Statictics → Select the Product Name & date range and click on Generate Report.",
        },
        report_prod: {
            answer: "Login to QRmor portal → Click on Generate QR and View Details → Select Product Report → Select the type of Report (Simple/Detailed). If you select Detailed Report then you can select the QR ID for which you want the report or generate for all QRs.<br/><br/><b>Note: The Simple Report contains the Product Details and the QR ID and batch count for each QR. The Detailed Report contains the detailed information upto the comments given for each Batch</b>",
        },
        report_qr: {
            answer: "Login to QRmor portal → Click on Generate QR and View Details → Click on View Batch Details → Click on View & Print QR Report",
        },
        report_batch: {
            answer: "Login to QRmor portal → Click on Generate QR and View Details → Click on View Batch Details → Click on View & Pront Report against the Batch you want to generate the report for.",
        },
        reports_custom_escalate: {
            escalate: true,
            escalateNote: "Custom report needs go to our data team — tell us what you're looking for.",
        },
        other_escalate: {
            escalate: true,
            escalateNote: "Tell us what's going on and we'll follow up by email.",
        },
    },

    user: {
        root: {
            prompt: "What can I help with?",
            options: [
                { label: "Adding batches", next: "batch_create_root" },
                { label: "Validating batches", next: "batch_validate_root" },
                { label: "Batch reports", next: "batch_report_root" },
                { label: "Something else", next: "other_escalate" },
            ],
        },

        // ---------------- Adding batches ----------------
        batch_create_root: {
            prompt: "Adding batches — what do you need?",
            options: [
                { label: "Add batch details", next: "add_batch" },
                { label: "I'm facing an issue", next: "batch_create_other_escalate" },
            ],
        },
        add_batch: {
            answer:
                "Login to QRmor portal → Click on Add and Validate Batch Details → Click on Add & Validate Batch Details → Enter the Batch Number, Manufacture Date, Expiry Date, click on Add Batch. <br /><br /><b>Note: The Batches added can be accessable by the end user only upon validation. Also the user who adds the batch details cannot validate them. One can only validate details added by other users.</b>",
        },
        batch_create_other_escalate: {
            escalate: true,
            escalateNote: "Tell us what's going on and we'll follow up by email.",
        },

        // ---------------- Validating batches ----------------
        batch_validate_root: {
            prompt: "Validating batches — what do you need?",
            options: [
                { label: "Validate batch Details", next: "validate_batch" },
                { label: "I'm facing an issue", next: "validation_escalate" },
            ],
        },
        validate_batch: {
            answer:
                "Login to QRmor portal → Click on Add and Validate Batch Details → Click on Add & Validate Batch Details → click on Approve against the Batch you want to approve.</b>",
        },
        validation_escalate: {
            escalate: true,
            escalateNote: "That needs a closer look — share the batch number and a screenshot of the error if you have one.",
        },

        // ---------------- Batch reports ----------------
        batch_report_root: {
            answer: "Login to QRmor portal → Click on Add and Validate Batch Details → Click on Add & Validate Batch Details of the QR to which batch belongs to→ Click on View & Print Report against the Batch you want to generate the report for."
        },
        other_escalate: {
            escalate: true,
            escalateNote: "Tell us what's going on and we'll follow up by email.",
        },
    },

    guest: {
        root: {
            prompt: "Hi, how can we help?",
            options: [
                { label: "Verifying a QR code", next: "qr_root" },
                { label: "Recalled Batch", next: "recall_root" },
                { label: "I think I scanned a Counterfeit product", next: "counterfeit_escalate" },
            ],
        },

        // ---------------- QR verification ----------------
        qr_root: {
            prompt: "QR verification — what do you need?",
            options: [
                { label: "How do I verify a product QR code?", next: "how_verify" },
                { label: "What does 'Verified' vs 'Could not Verify' mean?", next: "verify_meaning" },
                { label: "Device Compatability", next: "device_comp" },
            ],
        },
        how_verify: {
            answer:
                "Scan the QR code on the pack using your phone camera or any third-party scanner. You will be re-directed to the QRmor Verification page. Scan the same QR code again (may be twice in some cases. Do as prompted) and enter the Batch No. from the medicine strip (when asked) and submit to get the result.<br /><br /><b>Note: Please enable the Location and Camera services to run the process smoothly.</b>",
        },
        verify_meaning: {
            answer:
                "'Verified' means the QR code matches a genuine, registered batch. 'Could not Verify' means the QRmor code could be damaged,  fake, or you might be scanning with an unsupported device. Please try using another device for verification.",
        },
        device_comp: {
            answer: `<b>What your phone needs to use the scanner:</b><br /><br /><b style="font-size:10px;opacity:.6;letter-spacing:.06em;">OS &amp; BROWSER</b><br />✅ Android <b>9+</b> or iOS <b>13+</b><br />⚠️ On iPhone, use <b>Safari</b> — Chrome/Firefox restrict camera on iOS<br />❌ Incognito/Private mode blocks the camera — use a normal tab<br /><br /><b style="font-size:10px;opacity:.6;letter-spacing:.06em;">CAMERA</b><br />✅ Rear camera with <b>autofocus</b> (most phones from 2018+)<br />✅ 8 MP or higher resolution recommended<br />❌ Fixed-focus cameras may not resolve QR codes clearly<br /><br /><b style="font-size:10px;opacity:.6;letter-spacing:.06em;">PERMISSIONS</b><br />✅ <b>Camera access</b> granted to your browser — Settings → Browser → Camera<br />✅ <b>Location access</b> granted to your browser — Settings → Browser → Location<br />✅ JavaScript enabled in the browser<br /><br /><b style="font-size:10px;opacity:.6;letter-spacing:.06em;">CONNECTIVITY</b><br />✅ Active internet connection required — verification is a live lookup<br />⚠️ 2G/EDGE works but may be slow — 4G or Wi-Fi recommended<br /><br /><span style="border-left:3px solid #F5A623;padding-left:8px;"><b style="color:#F5A623;font-size:10px;letter-spacing:.06em;">QUICK TIP</b><br />Still won't scan? Go back and choose <b>"I'm facing an issue"</b> to raise it with our team.</span>`
        },
        // ---------------- Recalls / safety ----------------
        recall_root: {
            prompt: "Recalled or unsafe products — what do you need?",
            options: [
                { label: "What does a recall mean?", next: "recalled" },
                { label: "I have a recalled product, what do I do?", next: "recall_action" },
            ],
        },
        recalled: {
            answer:
                "A 'Recalled' result means this specific batch has been pulled from the market for safety reasons.",
        },
        recall_action: {
            answer:
                "Stop using the product immediately and return it to the place of purchase. Keep the pack and QR code visible in case they ask for it.",
        },

        counterfeit_escalate: {
            escalate: true,
            escalateNote: "Thanks for flagging this — share the QR code/batch number and where you purchased it, and our team will investigate.",
        },
    },
};

const ROLE_LABELS = { admin: "Admin", user: "General User", guest: "Guest" };

// Each client site sets this however fits your deployment:
// e.g. injected by the host page as a global, or a build-time env var.
// This is what tells the backend which company's Zammad Organization to file the ticket under.
const COMPANY_ID = "Dem_Pharma_26";

/* ============================================================
   COMPONENT
   ============================================================ */
export default function SupportCenter() {
    const navigate = useNavigate();
    const role = sessionStorage.getItem('isLoggedIn') === 'true' ? (sessionStorage.getItem('isAdmin') === 'true' ? 'admin' : 'user') : 'guest'

    const [messages, setMessages] = useState([]);
    const [ticketBadge, setTicketBadge] = useState("");
    // Tracks the labels the user clicked through (e.g. ["Product Licenses", "License is stuck or rejected"])
    // so the backend can classify the ticket by category.
    const [categoryPath, setCategoryPath] = useState([]);
    const [currentNodeId, setCurrentNodeId] = useState("root");
    // Maps nodeId -> the breadcrumb of labels that led to it. Lets us
    // recompute the correct path fresh from wherever the user actually
    // clicked, instead of blindly appending to one running list.
    const pathByNodeIdRef = useRef({ root: [] });
    const streamRef = useRef(null);

    function cryptoId() {
        return Math.random().toString(36).slice(2) + Date.now();
    }

    function renderNode(nodeId, msgList) {
        const tree = TREES[role];
        const node = tree[nodeId];
        if (!node) return msgList;
        const next = [...msgList];
        if (node.prompt) next.push({ type: "bot-text", text: node.prompt, id: cryptoId() });
        // Tag the options message with the node it belongs to, so a click on
        // ANY option set — even one still visible higher up from earlier in
        // the chat — knows exactly which node it's coming from.
        if (node.options) {
            next.push({ type: "options", options: node.options, nodeId, id: cryptoId() });
        } else if (node.answer) {
            next.push({ type: "answer", text: node.answer, id: cryptoId() });
            next.push({
                type: "options",
                options: [{ label: "⬅ Back to Main Menu", next: "root", isBackToMenu: true }],
                nodeId,
                id: cryptoId(),
            });
        } else if (node.escalate) {
            next.push({ type: "escalate", note: node.escalateNote, id: cryptoId() });
            next.push({
                type: "options",
                options: [{ label: "⬅ Back to Main Menu", next: "root", isBackToMenu: true }],
                nodeId,
                id: cryptoId(),
            });
        }
        return next;
    }

    useEffect(() => {
        pathByNodeIdRef.current = { root: [] };
        setCurrentNodeId("root");
        setMessages(renderNode("root", []));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [role]);

    useEffect(() => {
        if (streamRef.current) streamRef.current.scrollTop = streamRef.current.scrollHeight;
    }, [messages]);

    // handleChoice now takes the nodeId the clicked option came from, so the
    // breadcrumb is always recomputed from that node's own known path —
    // never blindly appended to whatever the last click happened to be.
    function handleChoice(opt, fromNodeId) {
        if (opt.isBackToMenu) {
            pathByNodeIdRef.current = { root: [] };
            setCategoryPath([]);
            setCurrentNodeId("root");
            setMessages((prev) => {
                const withUser = [...prev, { type: "user-text", text: opt.label, id: cryptoId() }];
                return renderNode("root", withUser);
            });
            return;
        }

        const basePath = pathByNodeIdRef.current[fromNodeId] || [];
        const newPath = [...basePath, opt.label];
        pathByNodeIdRef.current[opt.next] = newPath;
        setCategoryPath(newPath);
        setCurrentNodeId(opt.next);

        setMessages((prev) => {
            const withUser = [...prev, { type: "user-text", text: opt.label, id: cryptoId() }];
            return renderNode(opt.next, withUser);
        });
    }

    function handleRestart() {
        pathByNodeIdRef.current = { root: [] };
        setCategoryPath([]);
        setCurrentNodeId("root");
        setMessages(renderNode("root", []));
    }

    async function handleEscalateSubmit(email, msg, onDone) {
        try {
            const resp = await fetch("https://qrmor.cadilapharma.com:5917/api/support/escalate", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    companyId: COMPANY_ID,
                    role,
                    email,
                    message: msg,
                    categoryPath, // e.g. ["Product Licenses", "License is stuck or rejected"]
                }),
            });
            console.log(resp)

            if (!resp.ok) throw new Error(`Server responded ${resp.status}`);
            const data = await resp.json();
            // data = { ticketId, ticketNumber } from your backend / Zammad

            onDone(data.ticketNumber, email);
            setTicketBadge(`Last ticket filed: ${data.ticketNumber}`);
        } catch (err) {
            console.error("Failed to file ticket:", err);
            onDone(null, email, "We couldn't reach the support system. Please try again.");
        }
    }

    return (
        <>
            <header className="support-header">
                <button onClick={() => navigate('/')} className="back-button">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
                    </svg>
                    Back
                </button>
            </header>
            <div className="sc-wrap">
                <div className="sc-header">
                    <div>
                        <p className="sc-subtitle">Answers when we have them. A real person when we don't.</p>
                    </div>
                </div>

                <div className="sc-panel">
                    <div className="sc-stream" ref={streamRef}>
                        {messages.map((m) => (
                            <MessageBlock key={m.id} m={m} onChoice={handleChoice} onEscalate={handleEscalateSubmit} currentNodeId={currentNodeId} />
                        ))}
                    </div>
                    <div className="sc-composer">
                        <span className="sc-composer-hint">
                            {role === "guest" ? "Browsing as Guest" : `Signed in as ${ROLE_LABELS[role]} `}
                        </span>
                        <button className="sc-restart-btn" onClick={handleRestart}>
                            ↺ START OVER
                        </button>
                    </div>
                </div>
                {ticketBadge && <div className="sc-ticket-badge">{ticketBadge}</div>}
            </div>
        </>
    );
}

function MessageBlock({ m, onChoice, onEscalate, currentNodeId }) {
    if (m.type === "bot-text") {
        return (
            <div className="sc-row bot">
                <div className="sc-bubble">{m.text}</div>
            </div>
        );
    }
    if (m.type === "user-text") {
        return (
            <div className="sc-row user">
                <div className="sc-bubble">{m.text}</div>
            </div>
        );
    }
    if (m.type === "options") {
        const isStale = m.nodeId && m.nodeId !== currentNodeId;
        return (
            <div className="sc-row bot" style={isStale ? { opacity: 0.45 } : undefined}>
                <div className="sc-options">
                    {m.options.map((opt, i) => (
                        <button
                            key={i}
                            className="sc-opt-btn"
                            onClick={() => onChoice(opt, m.nodeId)}
                            disabled={isStale}
                            style={isStale ? { cursor: "not-allowed" } : undefined}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            </div>
        );
    }
    if (m.type === "answer") {
        return (
            <div className="sc-row bot">
                <div className="sc-bubble answer">
                    <span className="sc-tag resolved">ANSWERED</span>
                    <div dangerouslySetInnerHTML={{ __html: m.text }}></div>
                </div>
            </div>
        );
    }
    if (m.type === "escalate") {
        return <EscalateForm note={m.note} onEscalate={onEscalate} />;
    }
    return null;
}

function EscalateForm({ note, onEscalate }) {
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [error, setError] = useState("");
    const [sent, setSent] = useState(null);
    const [sending, setSending] = useState(false);
    const [emailDisabled, setEmailDisabled] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("email")) {
            setEmail(sessionStorage.getItem("email"));
            setEmailDisabled(true);
        }
        else {
            setEmailDisabled(false);
        }
    }, []);

    function submit() {
        if (!email.includes("@")) {
            setError("Enter a valid email address.");
            return;
        }
        if (!msg.trim()) {
            setError("Add a few details so the team has context.");
            return;
        }
        setError("");
        setSending(true);
        onEscalate(email, msg, (ticketId, sentEmail, failureMsg) => {
            setSending(false);
            if (!ticketId) {
                setError(failureMsg || "Something went wrong. Please try again.");
                return;
            }
            setSent({ ticketId, email: sentEmail });
        });
    }

    return (
        <div className="sc-row bot">
            <div style={{ maxWidth: "88%" }}>
                <span className="sc-tag escalated">NEEDS A HUMAN</span>
                <div className="sc-bubble" style={{ marginTop: 4 }}>
                    {note}
                </div>
                <div className="sc-email-form">
                    {sent ? (
                        <div className="sc-confirm-text">
                            Sent. Ticket <strong style={{ fontFamily: "var(--font-mono)" }}>{sent.ticketId}</strong> created —
                            we'll reply to <strong>{sent.email}</strong>.
                        </div>
                    ) : (
                        <>
                            <label>Your email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@example.com"
                                disabled={emailDisabled}
                            />
                            <label>Details</label>
                            <textarea
                                rows={3}
                                value={msg}
                                onChange={(e) => setMsg(e.target.value)}
                                placeholder="What's going on?"
                            />
                            {error && <div className="sc-form-error">{error}</div>}
                            <button onClick={submit} disabled={sending}>
                                {sending ? "Sending…" : "Send to support team"}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}